/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShareForm } from '../../models/create-share-form';
import { ShareModel } from '../../models/share-model';

export interface UserShareV20OrganizationCoordinationSharePost$Params {

/**
 * The id of the Organization.
 */
  organizationId: string;

/**
 * The id of the Coordination.
 */
  coordinationId: string;
  'api-version'?: string;
  
    /**
     * - The DmaObjectRef of the share.
     * - The AllowedUsers to this share their email addresses.
     * - The DisplayName of the share.
     * - The Description of the share.
     * - The Expiration of the share.
     */
    body: CreateShareForm
}

export function userShareV20OrganizationCoordinationSharePost(http: HttpClient, rootUrl: string, params: UserShareV20OrganizationCoordinationSharePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareModel>> {
  const rb = new RequestBuilder(rootUrl, userShareV20OrganizationCoordinationSharePost.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('coordinationId', params.coordinationId, {});
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShareModel>;
    })
  );
}

userShareV20OrganizationCoordinationSharePost.PATH = '/api/user-share/v2-0/organization/{organizationId}/coordination/{coordinationId}/share';
